import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { AvatarCreationWizard } from '../../../../../features/admin/AvatarCreationWizard'

/* ───── Route Definition ───── */

export const Route = createFileRoute(
  '/_authenticated/admin/collection/avatars/new',
)({
  component: AvatarCreationRoute,
})

/* ───── Route Component ───── */

function AvatarCreationRoute() {
  const navigate = useNavigate()
  const [open, setOpen] = useState(true)

  return (
    <AvatarCreationWizard
      open={open}
      onClose={() => {
        setOpen(false)
        navigate({ to: '/admin/collection' })
      }}
      onSuccess={() => {
        setOpen(false)
        navigate({ to: '/admin/collection' })
      }}
    />
  )
}
